export const searchFormConstants = {
  SET_PRICING: "SET_PRICING",
  FETCH_PRICE_REQUEST: "FETCH_PRICE_REQUEST",
  FETCH_PRICE_SUCCESS: "FETCH_PRICE_SUCCESS",
  FETCH_PRICE_FAILURE: "FETCH_PRICE_FAILURE",
};
